// @ts-strict-ignore
import dayjs from 'dayjs'

const frequencyMap = {
  weekly: 'week',
  monthly: 'month',
  yearly: 'year',
}

const twoDecimalPlaces = (n) => {
  return (Number.isInteger(n) ? n : Math.round(n * 100) / 100).toFixed(2)
}

export const calculation = (
  { startingAmount, targetAmount, contribution, contributionFrequency, interestRate },
  now = Date.now,
) => {
  const savingsData = []
  let amount = startingAmount
  let interestSaved = 0
  let steps = 0
  while (targetAmount - 0.0000001 > amount && steps < 10000) {
    steps += 1
    savingsData.push(amount)
    if (contributionFrequency === 'weekly') {
      interestSaved += amount * ((1 + interestRate / 100) ** (1 / 52) - 1)
      amount *= (1 + interestRate / 100) ** (1 / 52)
    } else if (contributionFrequency === 'monthly') {
      interestSaved += amount * ((1 + interestRate / 100) ** (1 / 12) - 1)
      amount *= (1 + interestRate / 100) ** (1 / 12)
    } else {
      interestSaved += (amount * interestRate) / 100
      amount *= 1 + interestRate / 100
    }
    amount += contribution
  }
  savingsData.push(amount)

  let savingTime

  if (contributionFrequency === 'weekly' && steps >= 52) {
    savingTime = `${Math.floor(steps / 52)} year${steps === 52 ? '' : 's'}`
    if (steps % 52 !== 0) {
      savingTime += ` and ${steps % 52} week${steps % 52 === 1 ? '' : 's'}`
    }
    if (steps / 52 > 100) {
      savingTime = 'over 100 years'
      interestSaved = 0
    }
  } else if (contributionFrequency === 'monthly' && steps >= 12) {
    savingTime = `${Math.floor(steps / 12)} year${steps === 12 ? '' : 's'}`
    if (steps % 12 !== 0) {
      savingTime += ` and ${steps % 12} month${steps % 12 === 1 ? '' : 's'}`
    }
    if (steps / 12 > 100) {
      savingTime = 'over 100 years'
      interestSaved = 0
    }
  } else if (steps > 100) {
    savingTime = 'over 100 years'
    interestSaved = 0
  } else {
    savingTime = `${steps} ${frequencyMap[contributionFrequency]}${steps === 1 ? '' : 's'}`
  }

  const dateReachedGoal = dayjs(now())
    .add(steps, frequencyMap[contributionFrequency])
    .format('D MMM YYYY')

  return {
    savingTime,
    dateReachedGoal,
    steps,
    interestSaved: twoDecimalPlaces(interestSaved),
    savingsData,
  }
}
